import { buildHttpHeaders } from "../../utils/buildHttpHeaders";

const PATH: string = `terminologies`;


export async function getTerminologiesAsync(backendHeader: string, signal?: AbortSignal) {

  try {
    const response = await fetch(PATH, {
      headers: buildHttpHeaders(backendHeader),
      signal: signal
    });

    const terminologies = await response.json();
    return terminologies;
  }
  catch (error) {
    console.log(error);

    throw error;
  }
};